import { memo } from 'react'

import RangeSlider from '@/molecules/RangeSlider'
import usePriceRangeStore from '@/zustand/stores/price-range/usePriceRangeStore'

import usePriceRangeState from './functions/usePriceRangeState'
import Fieldset from './includes/Fieldset'
import { PriceRangeProps } from './ts'

function PriceRange({ min = 0, max = 0, range }: PriceRangeProps) {
  const { priceRange, fieldset } = usePriceRangeStore()
  const { handleMove, handleMoveEnd } = usePriceRangeState(min, max, range)

  return (
    <div>
      <Fieldset range={fieldset} max={max} />
      <div className="px-2.5">
        <RangeSlider
          min={min}
          max={max}
          range={priceRange}
          onMove={handleMove}
          onMoveEnd={handleMoveEnd}
        />
      </div>
    </div>
  )
}

export default memo(PriceRange)
